import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Input, Button, List, Typography, Spin, message } from "antd";
import { useVoiceToText } from "react-speakup";
import { AI_API_CHAT_URL } from "../../utils/contrains";
import { req_list_aps_courseplan } from "../../api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faUser,
  faComments,
  faStop,
  faCaretSquareUp,
} from "@fortawesome/free-solid-svg-icons";
import "./create-course-selection.css";

const { Title } = Typography;

const CreateCourseSelection = (props) => {
  const [isListening, setIsListening] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [assistantTyping, setAssistantTyping] = useState("");
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [typingTimer, setTypingTimer] = useState(null); // 儲存計時器 ID

  // Voice to text hook
  const { startListening, stopListening, transcript, reset } = useVoiceToText({
    continuous: false,
    lang: "zh-TW",
  });

  // Function to fetch course options
  const api_list_courses = useCallback(async () => {
    const { token, userCode } = props.user;
    try {
      const data = await req_list_aps_courseplan(userCode, token);
      if (data) {
        const {
          TwName,
          CoursesDescription,
          EducationalSystemTwName,
          StudentSemester,
        } = data;
        setMessages([
          {
            role: "user",
            content: `我希望你扮演一位台南應用科技大學課程規劃人員，我的姓名為${TwName}就讀台南應用科技大學${EducationalSystemTwName}，可學習計有${CoursesDescription}等課程，
                      且今年我是${StudentSemester}學生，請你依據可學習課程進行建議說明。若我提問實際開課地點及授課老師資訊，則回答「具體開課資訊，請洽系辦或課務組」，若我提問內容與
                      學習課程無關，直接回答「無相關適合課程，請洽系辦或課務組」。以下對話請用繁體中文回答。`,
          },
          {
            role: "system",
            content: `${TwName}同學，你好！有什麼可以協助的呢?`,
          },
        ]);
      } else {
        // Fallback message if no data is returned
        const fallbackData =
          "程式設計（一）是一門必修課預計於一上開課; 程式設計（二）是一門必修課預計於一下開課; 會計資訊系統是一門必修課預計於一下開課; 資訊管理導論是一門必修課預計於一上開課; 資料結構是一門必修課預計於二上開課; 計算機網路是一門必修課預計於三上開課; 系統分析與設計是一門必修課預計於二下開課; 物件導向程式設計是一門選修課預計於二下開課; 離散數學是一門選修課預計於二上開課; 網路管理是一門選修課預計於四上開課; 軟體工程是一門選修課預計於四上開課; 品質管理是一門選修課預計於四下開課; 資料探勘是一門選修課預計於二下開課; 企業資源規劃實務是一門選修課預計於三下開課; 數位教材製作是一門選修課預計於二下開課; 統計應用軟體是一門選修課預計於三上開課; ＲＦＩＤ概論是一門選修課預計於一下開課; 資訊安全是一門選修課預計於四上開課; ＲＦＩＤ與電子商務應用是一門選修課預計於四下開課; 職場實習是一門選修課預計於四上開課; 資訊管理個案是一門選修課預計於四下開課; 演算法是一門選修課預計於四下開課; 數位內容概論與應用是一門選修課預計於二上開課; 雲端技術概論是一門選修課預計於三下開課; 計算機概論是一門必修課預計於一上開課; 電子商務是一門必修課預計於一下開課; 資料庫系統與管理是一門必修課預計於二上開課; 進階網頁程式設計是一門選修課預計於四上開課; 企劃書製作與簡報是一門必修課預計於三上開課; 物聯網概論是一門選修課預計於二上開課; 在地型產業創新服務實務是一門選修課預計於三下開課; 資訊概論是一門選修課預計於一上開課; 資訊倫理與法律是一門選修課預計於二上開課; ＡＰＰ開發與應用是一門選修課預計於三上開課; 現代網頁製作是一門選修課預計於一下開課; 數位行銷是一門必修課預計於三上開課; 資料分析與統計應用是一門必修課預計於二下開課; 專題研究是一門必修課預計於三上開課; 專題設計是一門必修課預計於三下開課; ２Ｄ動畫設計是一門選修課預計於一下開課; 數位影音剪輯是一門選修課預計於一下開課; 擴增實境是一門選修課預計於三上開課; 商業報表分析是一門選修課預計於四下開課; 專案管理是一門選修課預計於四下開課; Ｃ＃程式設計是一門選修課預計於三上開課; 虛擬實境是一門選修課預計於三上開課; 商業流程管理是一門必修課預計於二上開課; 企業資源規劃是一門必修課預計於二下開課; 系統管理是一門必修課預計於三下開課; 作業系統是一門選修課預計於三下開課; 網頁程式設計是一門選修課預計於三下開課; 創客進階技術實作是一門選修課預計於三上開課; 機器學習是一門選修課預計於四上開課; 創客與創新技術實務是一門必修課預計於一下開課; 大數據分析應用是一門必修課預計於三上開課; 創客實務專題是一門選修課預計於四上開課; 企業管理是一門必修課預計於一上開課; 會計學是一門必修課預計於一上開課; 校外實習（一）是一門選修課預計於四上開課; 校外實習（二）是一門選修課預計於四下開課; 跨域自主學習是一門選修課預計於四上開課; 商業日文（一）是一門選修課預計於一上開課; 商業日文（二）是一門選修課預計於一下開課; 日文能力檢定（一）是一門選修課預計於二上開課; 日文能力檢定（二）是一門選修課預計於二下開課; 進階日文能力檢定（一）是一門選修課預計於三上開課; 進階日文能力檢定（二）是一門選修課預計於三下開課; ３Ｄ建模是一門選修課預計於一下開課; ３Ｄ動畫與場景設計是一門選修課預計於二上開課; 遊戲互動設計是一門選修課預計於二下開課; 經濟學是一門選修課預計於二下開課; 多媒體互動設計實務是一門選修課預計於二下開課; 智慧科技應用實務是一門選修課預計於三上開課; AR/VR整合設計實務是一門選修課預計於三下開課; 人工智慧是一門選修課預計於三下開課; 智慧產業創新管理實務是一門選修課預計於四上開課; 計算機結構是一門選修課預計於四上開課; 遊戲企劃與製作是一門選修課預計於四上開課; 創客實務技術專題是一門選修課預計於四上開課; 專題寫作是一門選修課預計於四下開課; 電腦與資訊應用是一門必修課預計於一上開課; 大二英文是一門必修課預計於二上開課; 多元服務學習（一）是一門必修課預計於一上開課; 多元服務學習（二）是一門必修課預計於一下開課; 本國語文（一）是一門必修課預計於一上開課; 本國語文（二）是一門必修課預計於一下開課; 體育運動（一）是一門必修課預計於一上開課; 體育運動（二）是一門必修課預計於一下開課; 實用英文（一）是一門必修課預計於一上開課; 實用英文（二）是一門必修課預計於一下開課; 產業前景與職涯規劃是一門必修課預計於一下開課; 工作崗位訓練是一門選修課預計於四上開課; ＡＰＰ實務專題是一門選修課預計於四上開課; 發展通識是一門選修課預計於二上開課; 發展通識是一門選修課預計於二下開課; 發展通識是一門選修課預計於三上開課; 發展通識是一門選修課預計於三下開課; 故事腳本設計與應用是一門選修課預計於二上開課; 新興資訊科技主題是一門選修課預計於三下開課"; // Truncated for brevity
        setMessages([
          {
            role: "user",
            content: `我希望你扮演一位台灣台南應用科技大學的課程規劃人員，我可學習計有${fallbackData}等課程，且今年我是二上學生，請你依據可學習課程進行建議說明。若我提問實際開課地點及授課老師資訊，則回答'具體開課資訊，請洽系辦或課務組'，若我提問內容與學習課程無關，直接回答'無相關適合課程，請洽系辦或課務組'。以下對話請用繁體中文回答。`,
          },
          {
            role: "system",
            content: "你好！有什麼可以協助的呢?",
          },
        ]);
      }
    } catch (error) {
      console.error("Error fetching course options:", error);
    }
  }, [props.user]);

  // Effect to call api_list_courses on component mount
  useEffect(() => {
    api_list_courses();
  }, [api_list_courses]);

  // Effect to update user input with transcript
  useEffect(() => {
    if (transcript) {
      setUserInput(transcript);
    }
  }, [transcript]);

  const sendMessage = async (input) => {
    const url = AI_API_CHAT_URL;
    const data = {
      model: "gemma2",
      messages: [...messages, { role: "user", content: input }],
      stream: false,
    };

    setLoading(true);
    try {
      const response = await axios.post(url, data);
      if (response.status === 200) {
        typingEffect(response.data.message.content);
      } else {
        console.error(`Error: ${response.status}, ${response.data}`);
      }
    } catch (error) {
      console.error(
        `Error: ${error.response ? error.response.status : "Network Error"}, ${
          error.message
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  // Function to simulate typing effect
  const typingEffect = (content) => {
    setAssistantTyping("");
    let index = 0;
    const timer = setInterval(() => {
      if (index < content.length) {
        setAssistantTyping((prev) => prev + content[index]);
        index++;
      } else {
        clearInterval(timer);
        setTypingTimer(null); // 清除計時器 ID
        setMessages((prevMessages) => [
          ...prevMessages,
          { role: "system", content },
        ]);
        setAssistantTyping("");
      }
    }, 100);
    setTypingTimer(timer); // 保存計時器 ID
  };

  const handleToggleListening = () => {
    if (isListening) {
      stopListening();
    } else {
      startListening();
    }
    setIsListening(!isListening);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmedInput = userInput.trim();
    if (!userInput.trim()) {
      message.error("輸入欄位不能為空白！");
      return;
    }
    if (assistantTyping) {
      message.error("請等待目前的輸出完成！");
      return;
    }
    if (
      trimmedInput.toLowerCase() === "exit" ||
      trimmedInput.toLowerCase() === "quit"
    ) {
      console.log("再見！");
      return;
    }

    setMessages((prevMessages) => [
      ...prevMessages,
      { role: "user", content: trimmedInput },
    ]);

    // Clear user input and transcript after submission
    setUserInput("");

    sendMessage(trimmedInput);
    // Stop listening after submission
    setIsListening(false);
    stopListening();
    reset();
  };

  const handleInputChange = (event) => {
    setUserInput(event.target.value);
  };

  // 中斷輸出的按鈕功能
  const handleInterruptTyping = () => {
    if (typingTimer) {
      clearInterval(typingTimer); // 停止計時器
      setTypingTimer(null); // 清除計時器 ID
      setMessages((prevMessages) => [
        ...prevMessages,
        { role: "system", content: assistantTyping },
      ]); // 將目前的輸出加入歷史訊息
      setAssistantTyping(""); // 清空輸出狀態
    }
  };

  // Function to parse message content for bold formatting
  const parseContent = (content) =>
    content
      .split(/\*\*(.*?)\*\*/g)
      .map((part, index) =>
        index % 2 === 1 ? <strong key={index}>{part}</strong> : part
      );

  return (
    <div style={{ padding: "20px", maxWidth: "600px", margin: "auto" }}>
      <Title level={2}>修課建議服務</Title>
      <div
        style={{
          border: "1px solid #ccc",
          padding: "10px",
          height: "400px",
          overflowY: "scroll",
        }}
      >
        <List
          dataSource={messages}
          renderItem={(msg, index) =>
            index > 0 ? (
              <List.Item key={index}>
                <strong>
                  <FontAwesomeIcon
                    icon={msg.role === "user" ? faUser : faComments}
                    style={{ marginRight: "4px" }}
                  />
                  {msg.role === "user" ? "您提問" : "系辦"}:
                </strong>{" "}
                {parseContent(msg.content)}
              </List.Item>
            ) : null
          }
        />
        {assistantTyping && (
          <List.Item>
            <strong>
              <FontAwesomeIcon
                icon={faComments}
                style={{ marginRight: "4px" }}
              />
              系辦:
            </strong>{" "}
            <strong>{assistantTyping}</strong>
          </List.Item>
        )}
        {loading && !assistantTyping && (
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <Spin tip="回應中..." />
          </div>
        )}
      </div>
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", marginTop: "10px" }}
      >
        <Input
          value={userInput}
          disabled={assistantTyping} // 禁用輸入欄位
          onChange={handleInputChange}
          placeholder="請輸入您想學習的課程..."
          style={{
            flexGrow: 1,
            marginRight: "10px",
            backgroundColor: "#ffefd5",
          }}
        />
        <Button
          type="primary"
          htmlType="submit"
          disabled={!userInput.trim() || assistantTyping}
        >
          <FontAwesomeIcon
            icon={faCaretSquareUp}
            style={{ marginRight: "4px" }}
            color={assistantTyping ? "#666666" : "#E6E6E6"}
          />
          提問
        </Button>
        <Button
          onClick={handleInterruptTyping}
          disabled={!assistantTyping}
          style={{ marginLeft: "2px" }}
        >
          <FontAwesomeIcon
            icon={faStop}
            style={{ marginRight: "4px" }}
            color={assistantTyping ? "#4b0082" : "#E6E6E6"}
          />
          停止
        </Button>
        {/* Microphone Button */}
        <button
          type="button"
          onClick={handleToggleListening}
          className="hidden-on-mobile" // Add this class
          style={{
            marginLeft: "10px",
            backgroundColor: isListening ? "red" : "transparent",
            border: "none",
            cursor: "pointer",
            width: "40px",
            height: "30px",
            borderRadius: "50%",
            display: "none",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FontAwesomeIcon
            icon={faMicrophone}
            color={isListening ? "#fff" : "#000"}
          />
        </button>
      </form>
    </div>
  );
};
export default connect(
  (state) => ({ user: state.user }),
  {}
)(CreateCourseSelection);
